import { useEffect } from "react";

// Libraries & Packages
import { useLocation } from "react-router-dom";
import { useLenis } from "@studio-freight/react-lenis";

function ScrollToTop() {
  const { pathname } = useLocation();
  const lenis = useLenis(({ scroll }) => {});

  useEffect(() => {
    if (lenis) {
      lenis.scrollTo(0, { immediate: true });
    }
  }, [pathname, lenis]);

  return null;
}

export default ScrollToTop;
